import { DOP_AGREEMENT, MAIN_AGREEMENT, POLICY, SAFE_DEAL } from 'shared/common/constants';

export const rulesList = [
  {
    title: 'Общие правила',
    rules: [
      {
        rule: 'Размещайте на аватарках только свои реальные фото хорошего качества. Такое фото будет располагать к себе других пользователей. Непристойные картинки и провокационные изображения, конечно же, не пройдут модерацию.',
      },
      {
        rule: 'Будьте вежливы друг к другу. Отправлять в чате консультации картинки, видео и другие материалы непристойного или противозаконного содержания или ссылки на такие материалы нельзя.',
      },
      {
        rule: 'Не ругайтесь и не используйте ненормативную лексику даже в шутку, чтобы нечаянно не оскорбить других пользователей. Намеренные оскорбления и разжигание любого вида розни будут недопустимы, за это неминуемо последует блокировка аккаунта.',
      },
      {
        rule: 'Мы приветствуем любых пользователей независимо от их убеждений и мировоззрения, также как рады экспертам с разным уровнем экспертизы, но за нарушение правил сервиса и низкий уровень качества консультаций можем заблокировать аккаунт.',
      },
      {
        rule: `Сотрудники Consulty вправе читать все содержимое консультаций для улучшения качества работы сервиса, анализа качества консультаций и блокировки пользователей за нарушение правил. Это прописано в <a href="${POLICY}">политике конфиденциальности</a>.`,
      },
    ],
    content: `Оплата консультаций происходит согласно <a href="${SAFE_DEAL}">правилам безопасной сделки</a>.`,
  },
  {
    title: 'Правила для пользователей',
    rules: [
      {
        rule: 'Если консультация не нравится пользователю и есть малейшее подозрение на то, что она была оказана некачественно — мы вернем деньги в течение пары рабочих часов.',
      },
      {
        rule: 'Consulty связывает пользователей и экспертов, обеспечивает возможность легко выбрать эксперта, увидеть отзывы и информацию о нем и предоставляет техническую возможность провести консультацию. Мы тщательно отбираем экспертов и следим за качеством консультаций. Если работа выполняется некачественно — отключаем их от сервиса, выносим предупреждения, а деньги возвращаем пользователю в течение пары рабочих часов. Однако, мы не несем ответственность за то, как эксперты проводят свои консультации.',
      },
      {
        rule: 'Каждый пользователь должен оценить полученную консультацию, чтобы продолжить пользоваться Consulty. Это важно, чтобы на сервисе были только реальные отзывы об экспертах и другие пользователи могли легко выбирать нужного специалиста.',
      },
      {
        rule: 'Если мы посчитаем отзыв несправедливым, грубым, или содержим ложную информацию, то можем удалить его.',
      },
    ],
  },
  {
    title: 'Правила для экспертов',
    rules: [
      {
        rule: 'Стать экспертом Consulty может гражданин РФ после заключения допсоглашения к публичной оферте.',
      },
      {
        rule: 'Вывести заработанные деньги можно на карту российского банка. Пока что мы не работаем с иностранными банками и электронными кошельками.',
      },
      {
        rule: 'Если консультация была оказана некачественно или не полностью, пользователь может вернуть полную стоимость консультации. Мы всегда готовы объяснить эксперту почему так случилось и указать на ошибки. Но возврат средств происходит без предварительного объяснения причин эксперту.',
      },
      {
        rule: 'Если данные в вашем профиле будут недостоверными или неуместными для публикации, то он не пройдет верификацию и не будет опубликован. Это касается информации о себе, отзывов, дипломов, ссылок на личный сайт и социальные сети.',
      },
      {
        rule: 'Эксперт может получить льготный тариф или промокод на бесплатную консультацию по акции взамен на продвижение сервиса Consulty в социальных сетях. Но страницы эксперта в соцсетях, должны соответствовать стандартам сервиса, которые указываются в условиях акции.',
      },
      {
        rule: `Consulty не выдает эксперту никаких физических документов: <a href="${MAIN_AGREEMENT}">договор-оферта</a> и <a href="${DOP_AGREEMENT}"">допсоглашение</a> подписываются электронно, отчетные документы о работе предоставляют электронно в личном кабинете.`,
      },
      {
        rule: 'Если эксперт систематически игнорирует рекомендации по оказанию консультаций, вводит людей в заблуждение, публикует непристойную информацию — мы будем вынуждены заблокировать его профиль. \n Чтобы этого не случилось, следуйте простым рекомендациям: \n — Пишите без орфографических ошибок. Чтобы облегчить процесс, скачайте плагины для браузера, которые делают автопроверку текста. \n — Не навязывайте пользователю свой продукт/услугу в процессе консультации. Предложить что-то, можно после того, как вы ответили на вопросы пользователя. \n — Не грубите и не оскорбляйте пользователей. \n — Будьте терпеливы, некоторые люди могут дольше воспринимать информацию. \n — Ответственность за то, чтобы вас поняли, лежит на вас. Приложите усилия, чтобы собеседник услышал вас.',
      },
    ],
  },
];
